import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/CourseDetail'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class CourseDetailStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "CourseDetailStore",
			variables: true,
		})
	}
}

export async function load_CourseDetail(params) {
	await initClient()

	const store = new CourseDetailStore()

	await store.fetch(params)

	return {
		CourseDetail: store,
	}
}
